module.exports = __webpack_public_path__ + "img/img01.4d18b28c.png";